import { create } from 'zustand';
import api from '../utils/api';
import logger from '../utils/logger';

const useFeatureStore = create((set, get) => ({
  // State
  features: {}, // { feature_name: true/false }
  isLoading: false,
  error: null,
  lastUpdated: null,

  // Загрузка включенных фич
  loadFeatures: async () => {
    try {
      set({ isLoading: true, error: null });

      const response = await api.get('/api/features/enabled');
      const featuresMap = response.data.data;

      set({
        features: featuresMap,
        isLoading: false,
        lastUpdated: Date.now()
      });
    } catch (error) {
      logger.error('[featureStore] Error loading features:', error);
      set({ isLoading: false, error: error.message });

      // В случае ошибки используем пустой объект (все фичи выключены)
      set({ features: {} });
      // Re-throw чтобы usePolling зафиксировал failure и применил backoff —
      // иначе при offline хук бил бы каждые 60с без замедления
      throw error;
    }
  },

  // Проверка включена ли фича
  isEnabled: (featureName) => {
    const { features } = get();
    return features[featureName] === true;
  },

  // Получить все включенные фичи
  getEnabledFeatures: () => {
    const { features } = get();
    return Object.keys(features).filter(name => features[name]);
  },

  // Очистить фичи (при logout)
  clearFeatures: () => {
    set({ features: {}, lastUpdated: null });
  },

  // Переключить фичу (для админки)
  toggleFeature: async (featureId, currentEnabled) => {
    try {
      await api.put(`/api/features/${featureId}`, {
        enabled: !currentEnabled
      });

      // Перезагружаем фичи после изменения
      await get().loadFeatures();

      return true;
    } catch (error) {
      logger.error('[featureStore] Error toggling feature:', error);
      throw error;
    }
  },

  // Создать новую фичу (для админки)
  createFeature: async (featureData) => {
    try {
      await api.post('/api/features', featureData);

      // Перезагружаем фичи
      await get().loadFeatures();

      return true;
    } catch (error) {
      logger.error('[featureStore] Error creating feature:', error);
      throw error;
    }
  },

  // Удалить фичу (для админки)
  deleteFeature: async (featureId) => {
    try {
      await api.delete(`/api/features/${featureId}`);

      // Перезагружаем фичи
      await get().loadFeatures();

      return true;
    } catch (error) {
      logger.error('[featureStore] Error deleting feature:', error);
      throw error;
    }
  }
}));

export default useFeatureStore;
